import { ChangeDetectorRef, Component, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { NgFor } from "@angular/common";

@Component({
  selector: "app-horizontal-tabs",
  standalone: true,
  imports: [NgFor],
  templateUrl: "./horizontal-tabs.component.html",
  styleUrl: "./horizontal-tabs.component.scss"
})
export class HorizontalTabsComponent {
  @Input() tabs: { id: string, label: string }[] = [];
  @Input() selectedTab?: string = "";

  @Output() selectedTabChange = new EventEmitter<string>();
  //TODO: Remove this there can a two way binding on selected tab
  @Output() tabSelected = new EventEmitter<any>();

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["selectedTab"] && changes["selectedTab"].currentValue) {
      this.selectedTab = changes["selectedTab"].currentValue;
      this.cdr.detectChanges();
    }
  }

  selectTab(tabId: string) {
    this.selectedTab = tabId;
    this.tabSelected.emit(tabId);
  }
}
